exports.wrapRootElement = require('./src/constants/theme').default;
